import { z } from 'zod';
import { FieldActionSchema } from './actions.js';
import { GenericExtensionConditionsSchema } from './conditions.js';
import { ExtensionFieldIdSchema, ExtensionI18nStringSchema } from './extension.js';
// =============================================================================
// VALIDATION SCHEMAS
// =============================================================================
export const FieldTypeSchema = z.enum(['checkbox']);
// Future: z.enum(['checkbox', 'text', 'select', 'radio'])
export const ValidationRuleSchema = z
    .object({
    type: z.literal('required'),
    value: z.boolean().optional(), // Future: z.union([z.string(), z.number(), z.boolean()])
    message: ExtensionI18nStringSchema.refine((value) => Object.values(value).some((v) => typeof v === 'string' && v.length > 0), { message: 'Validation message must have at least one non-empty locale' }),
})
    .strict();
// =============================================================================
// BASE FIELD SCHEMA
// =============================================================================
export const BaseFieldSchema = z.object({
    id: ExtensionFieldIdSchema,
    type: FieldTypeSchema,
    actions: z.array(FieldActionSchema).optional(),
    when: GenericExtensionConditionsSchema.optional(),
    validation: z.array(ValidationRuleSchema).optional(),
});
// =============================================================================
// SPECIFIC FIELD SCHEMAS
// =============================================================================
/**
 * Checkbox Field Schema
 */
export const CheckboxFieldSchema = BaseFieldSchema.extend({
    type: z.literal('checkbox'),
    defaultChecked: z.boolean().optional().default(false),
    label: ExtensionI18nStringSchema.refine((value) => Object.values(value).some((v) => typeof v === 'string' && v.length > 0), { message: 'Label must have at least one non-empty locale' }),
});
// =============================================================================
// UNION FIELD SCHEMA
// =============================================================================
/**
 * Extension field schema (union of all field types)
 */
export const ExtensionFieldSchema = z.discriminatedUnion('type', [
    CheckboxFieldSchema,
    // TextFieldSchema
]);
//# sourceMappingURL=fields.js.map